import styled from "styled-components";

const ExpandedContentSection = styled.section``;

export { ExpandedContentSection };
